import React, { FC } from 'react';
import { Text } from 'react-native';
import i18n from 'i18n-js';

import { font, FontStyles } from '@styles/fonts';
import ColorsWrapper from '@styles/colors';
import { LinkStatus } from '@interfaces/search';
import { ncFileStatuses } from '@helpers';
import { ColorFunction } from '@styles/colors/types';

const LINK_STATUS_TEXT = {
  [LinkStatus.NOT_LINKED]: 'Not Linked',
  [LinkStatus.SINGLE_LINK]: 'To Single Job',
  [LinkStatus.MULTI_LINK]: 'To Multiple Jobs',
} as const;

const NC_FILE_TYPE_TEXT = {
  [ncFileStatuses.Unknown]: 'Unknown',
  [ncFileStatuses.Ignored]: 'Ignored',
  [ncFileStatuses.Setup]: 'Setup',
} as const;

interface LinkTextProps {
  linkStatus: LinkStatus;
  C: ColorFunction;
  ncFileStatus: (typeof ncFileStatuses)[keyof typeof ncFileStatuses];
  fontType?: keyof FontStyles;
  color?: string;
}

const CommonLinkText: FC<LinkTextProps> = ({ linkStatus, C, ncFileStatus, fontType = 'Subhead 1', color = 'Label/Light/Tertiary'}) => {
  let text = '';

  if ([ncFileStatuses.Unknown, ncFileStatuses.Ignored, ncFileStatuses.Setup].includes(ncFileStatus)) {
    text = NC_FILE_TYPE_TEXT[ncFileStatus];
  } else {
    text = LINK_STATUS_TEXT[linkStatus] ?? '';
  }

  return (
    <Text numberOfLines={1} style={[font[fontType], { color: C(color) }]}>
      {i18n.t(text)}
    </Text>
  );
};

export default ColorsWrapper(CommonLinkText);
